module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_03-35c021d41d8a6fc5df962520300afc88.jpg";